import React from 'react';
import { useTranslation } from 'react-i18next';
import { Navigate, useLocation } from 'react-router-dom';
import { Stack } from '@mui/material';

import Button from 'ui-lib/components/Button';
import FormikTextField from 'ui-lib/components/Inputs/TextField/FormikTextField';
import AuthLayout from 'web-shared/modules/auth/shared/components/AuthLayout';
import { AccessToken } from 'web-shared/services/access-token';

import { resetPasswordFieldNameGenerator } from './const';
import ResetPasswordPageFormikWrapper from './components/ResetPasswordPageFormikWrapper';

const { n } = resetPasswordFieldNameGenerator;

const ResetPasswordPage = () => {
  const { t } = useTranslation();
  const location = useLocation();

  const resetPasswordToken = new URLSearchParams(location.search).get('reset_password_token');
  const accessToken = AccessToken.getToken();

  if (!resetPasswordToken || !!accessToken) return <Navigate to='/sign-in' replace />;

  return (
    <ResetPasswordPageFormikWrapper resetPasswordToken={resetPasswordToken}>
      {({ handleSubmit, isValid, isSubmitting }) => (
        <AuthLayout onSubmit={handleSubmit} title={t('auth.title_resetPassword')}>
          {() => (
            <>
              <Stack>
                <FormikTextField
                  label={t('auth.label_createNewPassword')}
                  type='password'
                  name={n('password')}
                  disabled={isSubmitting}
                  required
                  testID='create-new-password'
                />
                <FormikTextField
                  label={t('auth.label_retypeNewPassword')}
                  type='password'
                  name={n('password_confirmation')}
                  disabled={isSubmitting}
                  required
                  testID='retype-new-password'
                />
              </Stack>
              <Button
                fullWidth
                type='submit'
                size='large'
                variant='contained'
                disabled={!isValid || isSubmitting}
                loading={isSubmitting}
                testID='save-password-button'
              >
                {t('auth.label_savePassword')}
              </Button>
            </>
          )}
        </AuthLayout>
      )}
    </ResetPasswordPageFormikWrapper>
  );
};

export default ResetPasswordPage;
